import React from 'react';
import { FACEBOOK_ID } from '../../../config/credentials';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { useDispatch } from 'react-redux';
import { signupFacebook as doSignup } from '@root/src/redux/auth/auth-action';

interface FacebookLoginButtonProps {
    onSubmit?: () => void;
}

const FacebookLoginButton: React.FC<FacebookLoginButtonProps> = props => {
    const dispatch = useDispatch();

    const responseFacebook = response => {
        dispatch(doSignup(response));

        if (props.onSubmit) {
            props.onSubmit();
        }
    };

    return (
        <FacebookLogin
            appId={FACEBOOK_ID}
            callback={responseFacebook}
            fields="name,email,picture,first_name,last_name"
            scope="public_profile,email"
            disableMobileRedirect={true}
            render={renderProps => (
                <button className="fbLogin" onClick={renderProps.onClick}>
                    <FontAwesomeIcon className="fa-3x text-charcoal" icon={faFacebook} />
                </button>
            )}
        />
    );
};

export default FacebookLoginButton;
